import { BrowseSetlistsScreen } from "@components/Search/BrowseSetlists";

export default BrowseSetlistsScreen;
